module.exports = {
  title: `Jeong.io`,
  description: `한걸음씩 천천히`,
  author: `JeongYeonJae`,
  introduction: `이것저것 쓰는 개발블로그`,
  siteUrl: `https://jeongyeon9254.github.io`, // Your blog site url
  social: {
    twitter: ``, // Your Twitter account
    github: `jeongyeon9254`, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: ``, // Your Facebook account
    linkedin: ``, // Your LinkedIn account
    instagram: ``, // Your Instagram account
  },
  icon: `content/assets/profile.png`, // Add your favicon
  keywords: [`blog`],
  comment: {
    disqusShortName: '', // Your disqus-short-name. check disqus.com.
    utterances: 'JaeYeopHan/gatsby-starter-bee', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: '',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: '0', // Add your google analytics tranking ID
  ad: '', // Add your google adsense publisherId `ca-pub-xxxxxxxxxx`
}
